import React from 'react';
import './Button.css';

const Button = ({ children, href, onClick, variant = "primary", className = "" }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  const buttonClass = `custom-button custom-button--${variant} ${className}`;

  return (
    <div className={buttonClass}>
      <div className="button-body">
        <div className="button-content">
          {href ? (
            <a href={href} onClick={handleClick}>{children}</a>
          ) : (
            <span onClick={handleClick}>{children}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Button;